import { IStore } from "services/indexdb/interface/istore"

export const DashboardStore: IStore = {
    Name: 'Dashboards',
    PrimaryField: 'id',
    minimumVersion: 2
}
